import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { from, Observable, of, throwError } from 'rxjs';
import { AppSettings } from '../PRE-LOAD/app-settings';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    listings = [];


    constructor(
        private httpClient: HttpClient,
        private appSettings: AppSettings
    ) {
    }

    private getTokenFromServer(): Observable<string> {
        let tokenUrl = `${this.appSettings.apiHostUrl}/api/token/${this.appSettings.apiBrand}`;

        return this.httpClient.get(tokenUrl).pipe(
            map((data: any) => {
                return data.token;
            }));
    }
    /**
     * @description Get listings data
     * @returns Returns an array of hard-coded products from the local json file
     */
    public getToken(): Observable<string> {
        let token = sessionStorage.getItem('token');

        if (token != null && token.length > 0) {

            let tokenExpiry = sessionStorage.getItem('tokenExpiry') as string;
            
            if (tokenExpiry > new Date().toTimeString())
            {
                return of(token);
            }
        }

        let tokenResponse = this.getTokenFromServer();
        return  tokenResponse.pipe(
            switchMap(data => {
                sessionStorage.setItem('token', data);
                sessionStorage.setItem('tokenExpiry', new Date(new Date().getTime() + 2*600000).toTimeString())
                return of(data);
            }),
            catchError(err => {
                console.error('HTTP ERROR: ', err);
                return throwError(err);
            }),
        );
    }

}
